(function(module) {
try {
  module = angular.module('betosyswebapp');
} catch (e) {
  module = angular.module('betosyswebapp', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('components/dashboard/tachoHistoryDashboard/tachoHistoryDashboard.tpl.html',
    '<div class="container-fluid mainContent"><div class="row"><div class="col-sm-12"><adf-dashboard name="{{dashBoardName}}" collapsible="{{collapsible}}" maximizable="{{maximizable}}" structure="7-5 (12/6-6)" adf-model="dashBoardModel" adf-widget-filter="widgetFilter"></adf-dashboard></div></div></div>');
}]);
})();



// WEBPACK FOOTER //
// ./.tmp/components/dashboard/tachoHistoryDashboard/tachoHistoryDashboard.tpl.js